let scoreSubscription, allScoresSubscription;

class ScoresController{
    /*@ngInject*/
    constructor(SocketService,$stateParams,EventService,$state){
        this.socket = SocketService;
        this.mode = $stateParams.level || 'easy';
        this.event = EventService;
        this.$state = $state;
    }
    $onInit(){
        this.socket.send('navigate',{page:'scores'});
        this.socket.send('getScores',{mode:this.mode});
        this.newScores=[];
        scoreSubscription = this.event.subscribe('getScores',data=>this.scores = data);
        allScoresSubscription = this.event.subscribe('score.new',data=>this.newScores.push(data));
    }
    $onDestroy(){
        scoreSubscription();
        allScoresSubscription();
    }
    ucFirst(string) {
        return string.charAt(0).toUpperCase() + string.slice(1);
    }
    go(location){
        if(location === 'characters'){
            this.socket.send('setMode',{mode:this.mode});
        }
        this.$state.go(location);
    }
}

export default ScoresController;


// WEBPACK FOOTER //
// ./public/app/scores/scores.controller.js